<template>
    <div class="align-self-stretch flex-fill d-flex align-items-center justify-content-center">
        <div class="text-center">
            <h6>No pending campaigns are found</h6>
            <a
                    :href="url"
                    class="btn btn-secondary my-4"
                    @click="$emit('generate')"
            >
                <i class="fas fa-plus"></i>
            </a>
            <div>Press the button to create them</div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      url: String,
    },
  }
</script>
